import React from 'react';
import { motion } from 'framer-motion';
import '../styles/AppLoading.css';
import dexLogo from '../assests/DexWallet Logo Symbol.png';

const AppLoading = ({ text = 'Loading...', overlay = false }) => {
    return (
        <div className={`app-loading ${overlay ? 'overlay' : ''}`}>
            {!overlay && (
                <div className="aurora-bg">
                    <div className="aurora-blob aurora-1" />
                    <div className="aurora-blob aurora-3" />
                    <div className="grid-overlay" />
                </div>
            )}

            <motion.div
                className="loading-content-wrapper"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
            >
                <div className="crystal-loader">
                    <motion.div
                        className="logo-wrapper"
                        animate={{
                            rotateY: [0, 180, 360],
                            filter: ['brightness(1)', 'brightness(1.2)', 'brightness(1)']
                        }}
                        transition={{
                            duration: 3,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    >
                        <div className="logo-glow" />
                        <img src={dexLogo} alt="Loading" className="loading-logo" />
                    </motion.div>

                    <div className="loader-ring">
                        <motion.div
                            className="ring-segment"
                            animate={{ rotate: 360 }}
                            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                        />
                    </div>
                </div>

                <motion.div
                    className="loading-status"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                >
                    <h2 className="loading-text">{text}</h2>
                    <div className="loading-dots-row">
                        {[0, 1, 2].map(i => (
                            <motion.div
                                key={i}
                                className="dot-pill"
                                animate={{
                                    height: [8, 16, 8],
                                    backgroundColor: ['rgba(255,255,255,0.2)', '#2b5aff', 'rgba(255,255,255,0.2)']
                                }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    delay: i * 0.2,
                                    ease: "easeInOut"
                                }}
                            />
                        ))}
                    </div>
                </motion.div>

            </motion.div>
        </div>
    );
};

export default AppLoading;
